import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    if (token) {
      localStorage.setItem("rp_token", token);
      refresh().then(() => nav("/dashboard"));
    } else {
      nav("/");
    }
  }, []);

  return <div className="min-h-screen flex items-center justify-center text-white/40 font-mono">Anmeldung wird abgeschlossen...</div>;
}
